<script lang="ts">
import {Result, Upcoming} from '../../model/model';
import {formatDate, shortCarInfo} from '../../util/format';
import EntityTable from './EntityTable.vue';
import SortableHeader from "../util/SortableHeader.vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    props: {
      upcomings: {
          type: [Object as () => Result<String, Array<Upcoming>> | Array<Upcoming>]
      }
    },
    methods: {
      shortCarInfo,
      formatDate(date: String | null): String {
        return formatDate(date)
      }
    },
    emits: ['car-select', 'hide-upcoming'],
    components: {FontAwesomeIcon, SortableHeader, EntityTable }
}
</script>

<template>
  <EntityTable :result="upcomings" :cols="5"
    loading-message="car.load.inProgress" empty-message="car.load.empty" error-message="car.load.fail" limited-message="car.load.limited"
    @entity-select="(u: Upcoming) => $emit('car-select', u.car)">
    <template #headers>
      <th>{{ $t('car.details.plate') }}</th>
      <th>{{ $t('car.details.info') }}</th>
      <th>{{ $t('work.details.name') }}</th>
      <th>{{ $t('work.details.date') }}</th>
      <th>{{ $t('work.hide') }}</th>
    </template>
    <template #entity="u: Upcoming">
      <td class="center">{{ u.car.plate }}</td>
      <td>{{ shortCarInfo(u.car) }}</td>
      <td>{{ u.licenseExpiry ? "License renewal" : u.customName }}</td>
      <td class="center">{{ formatDate(u.date) }}</td>
      <td class="center" @click.stop="$emit('hide-upcoming', u)"><font-awesome-icon icon="eye-slash" :title="$t('work.hide')" /></td>
    </template>
  </EntityTable>
</template>

<style scoped>
table.main {
  table-layout: auto;
}
</style>